import { IconButton } from "@mui/material"
import { EditOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { GoodsReceiptPallet } from "@/graphql/codegen/graphql"
import { isPalletAs400SyncPending } from "@/screens/WarehouseReceiving/utils"

interface GoodsReceiptPalletLpnCellProps {
  pallet: GoodsReceiptPallet
  canMaintain?: boolean
  isEditDisabled?: boolean
  onEdit?: () => void
}

export const GoodsReceiptPalletLpnCell: FC<GoodsReceiptPalletLpnCellProps> = ({
  pallet,
  canMaintain = true,
  isEditDisabled = false,
  onEdit,
}) => {
  return (
    <div className='flex items-center gap-1'>
      <span data-testid='lpn'>{pallet.lpn ?? "-"}</span>
      {canMaintain && (
        <IconButton
          size='small'
          onClick={onEdit}
          disabled={isEditDisabled || isPalletAs400SyncPending(pallet)}
          data-testid='lpn-edit-button'
        >
          <EditOutlined fontSize='small' />
        </IconButton>
      )}
    </div>
  )
}
